var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-container"},[(_vm.switchval)?_c('DeviceDoorRecordEcharts',{attrs:{"deviceId":_vm.deviceId}}):_c('DeviceDoorRecordTable',{attrs:{"deviceId":_vm.deviceId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }